// Claim lists and audience history are filtered per viewer on the server, and
// the app's QueryClient outlives a sign-out, so every key carries the viewer.
export const registryKeys = {
    all: [
        'registry'
    ],
    intelClaims: (viewer, subject)=>[
            ...registryKeys.all,
            'intel-claims',
            viewer,
            subject.kind,
            subject.id
        ],
    intelClaimsForLinks: (viewer, links)=>[
            ...registryKeys.all,
            'intel-claims',
            viewer,
            'links',
            links.map((l)=>`${l.linkRole}/${l.targetKind}/${l.targetId}`).join(',')
        ],
    audienceHistoryAll: [
        'registry',
        'intel-claim-audience-history'
    ],
    audienceHistory: (viewer, claimId)=>[
            ...registryKeys.audienceHistoryAll,
            viewer,
            claimId
        ],
    /** REG-55: merge events touching one record (loser or survivor). */ mergeEvents: (kind, id)=>[
            ...registryKeys.all,
            'merge-events',
            kind,
            id
        ],
    /** REG-54: pending match candidates for a resolve context. */ matchCandidates: (ctxKind, ctxId)=>[
            'registry-records',
            'match-candidates',
            ctxKind,
            ctxId
        ]
};
